<template>
  <Card :padding="20" shadow>
    <i-form
      :model="dados_aviso"
      :rules="rules_validate"
      ref="aviso"
      label-position="top"
    >
      <Row :gutter="16">
        <i-col :xs="24" :md="12" :lg="24">
          <form-item label="Nome" prop="nome">
            <i-input
              v-model="dados_aviso.nome"
              placeholder="Nome..."
              size="large"
            ></i-input>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="12">
          <form-item label="Data hora início" prop="data_hora_inicio">
            <div class="ivu-form-item">
              <DatePicker
                type="datetime"
                size="large"
                :options="disabledDatesBegin"
                :time-picker-options="{ steps: [1, 15] }"
                v-model="dados_aviso.data_hora_inicio"
                placement="bottom-end"
                format="dd/MM/yyyy HH:mm"
                placeholder="99/99/9999 99:99"
                style="width: 380px"
              ></DatePicker>
            </div>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="12">
          <form-item label="Data hora fim" prop="data_hora_fim">
            <DatePicker
              type="datetime"
              size="large"
              :options="disabledDatesEnd"
              :time-picker-options="{ steps: [1, 15] }"
              v-model="dados_aviso.data_hora_fim"
              placement="bottom-end"
              format="dd/MM/yyyy HH:mm"
              placeholder="99/99/9999 99:99"
              style="width: 380px"
            ></DatePicker>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="8">
          <form-item label="Sistema" prop="sistema">
            <i-select size="large" clearable v-model="dados_aviso.sistema">
              <i-option
                v-for="sistema in sistemas"
                :value="sistema.value"
                :key="sistema.key"
                >{{ sistema.value }}</i-option
              >
            </i-select>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="8">
          <form-item label="Estado" prop="estado">
            <i-select
              size="large"
              filterable
              clearable
              v-model="dados_aviso.estado"
              @input="getCidades"
            >
              <i-option
                v-for="estado in estados"
                :value="estado.id_estado"
                :key="estado.id_estado"
                >{{ estado.estado }}</i-option
              >
            </i-select>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="8">
          <form-item label="Cidade" prop="cidade">
            <i-select
              size="large"
              filterable
              clearable
              v-model="dados_aviso.cidade"
            >
              <i-option
                v-for="cidade in cidades"
                :value="cidade.nome"
                :key="cidade.nome"
                >{{ cidade.nome }}</i-option
              >
            </i-select>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="8">
          <form-item label="Tamanho" prop="tamanho_empresa">
            <i-select
              size="large"
              clearable
              v-model="dados_aviso.tamanho_empresa"
            >
              <i-option
                v-for="tamanho_empresa in tamanhos_empresa"
                :value="tamanho_empresa.nome"
                :key="tamanho_empresa.id"
                >{{ tamanho_empresa.nome }}</i-option
              >
            </i-select>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="8">
          <form-item label="Atividade" prop="atividade_empresa">
            <i-select
              size="large"
              clearable
              v-model="dados_aviso.atividade_empresa"
            >
              <i-option
                v-for="atividade_empresa in atividades_empresa"
                :value="atividade_empresa.nome"
                :key="atividade_empresa.id"
                >{{ atividade_empresa.nome }}</i-option
              >
            </i-select>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="8">
          <form-item label="Faturamento" prop="faturamento_empresa">
            <i-select
              size="large"
              clearable
              v-model="dados_aviso.faturamento_empresa"
            >
              <i-option
                v-for="faturamento_empresa in faturamentos_empresa"
                :value="faturamento_empresa.nome"
                :key="faturamento_empresa.id"
                >{{ faturamento_empresa.nome }}</i-option
              >
            </i-select>
          </form-item>
        </i-col>
        <i-col :xs="24" :md="12" :lg="24">
          <form-item label="Empresas" prop="empresa">
            <multiselect
              :options="empresas"
              :max-height="150"
              :multiple="true"
              v-model="dados_aviso.empresa"
              placeholder="Escolhas as empresas que receberão o aviso"
              selectLabel="Clique para adicionar"
              selectedLabel="Empresa selecionada"
              deselectLabel="Clique para remover"
              label="nome_empresa"
              track-by="id_empresa"
            ></multiselect>
          </form-item>
        </i-col>
      </Row>
    </i-form>
    <div :class="`floating-btn ${!ativar_botao ? 'hide' : ''}`">
      <i-button
        type="primary"
        shape="circle"
        icon="md-checkmark"
        @click="validar('aviso')"
      ></i-button>
    </div>
  </Card>
</template>

<script>
import "vue-multiselect/dist/vue-multiselect.min.css";
import { moment } from "../helpers/utils";

export default {
  props: ["id", "edit"],
  components: {
    Multiselect: () => import("vue-multiselect"),
    TheMask: () => import("vue-the-mask").then(({ TheMask }) => TheMask),
  },
  data() {
    /**
     * Custom validator de selects, pois o do iView não funciona como esperado
     */
    const validatorSelect = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    /**
     * Valida se foi escolhido os sistemas apresentados.
     */
    const validatorMultiSelect = (rule, value, callback) => {
      if (value === null) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    /**
     * Valida se as datas foram inseridas corretamente.
     */
    const validatorDate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    return {
      dados_aviso: {
        id_aviso: 0,
        nome: "",
        cidade: "",
        estado: "",
        atividade_empresa: "",
        tamanho_empresa: "",
        faturamento_empresa: "",
        data_hora_inicio: "",
        data_hora_fim: "",
        sistema: "",
        empresa: "",
      },
      rules_validate: {
        nome: [
          {
            required: true,
            message: "Informe a descrição do aviso.",
            min: 9,
            trigger: "blur",
          },
        ],
        data_hora_inicio: [
          {
            required: true,
            validator: validatorDate,
            message: "Informe a data de início referente a notificação.",
            trigger: "change",
          },
        ],
        data_hora_fim: [
          {
            required: true,
            validator: validatorDate,
            message: "Informe a data de fim referente a notificação.",
            trigger: "change",
          },
        ],
        sistema: [
          {
            required: true,
            validator: validatorSelect,
            message: "Informe o(s) sistema(s) desejado.",
            trigger: "change",
          },
        ],
        tamanho_empresa: [
          {
            required: false,
            validator: validatorSelect,
            message: "Informe o tamanho da(s) empresa(s).",
            trigger: "change",
          },
        ],
        atividade_empresa: [
          {
            required: false,
            validator: validatorSelect,
            message: "Informe a atividade da(s) empresa(s).",
            trigger: "change",
          },
        ],
        faturamento_empresa: [
          {
            required: false,
            validator: validatorSelect,
            message: "Informe o faturamento da(s) empresa(s).",
            trigger: "change",
          },
        ],
        estado: [
          {
            required: false,
            validator: validatorSelect,
            message:
              "Informe o estado em que a(s) empresa(s) está(ão) localizada(s).",
            trigger: "change",
          },
        ],
        cidade: [
          {
            required: false,
            validator: validatorSelect,
            message:
              "Informe a cidade em que a(s) empresa(s) está(ão) localizada(s).",
            trigger: "change",
          },
        ],
        empresa: [
          {
            required: false,
            validator: validatorMultiSelect,
            message: "Informe a(s) empresa(s) que receberão o aviso.",
            trigger: "change",
          },
        ],
      },
      ativar_botao: false,
      estados: [],
      cidades: [],
      atividades_empresa: [],
      tamanhos_empresa: [],
      faturamentos_empresa: [],
      empresas: [],
      sistemas: [
        { value: "comercio", key: "comercio" },
        { value: "revenda", key: "revenda" },
        { value: "intranet", key: "intranet" },
      ],
      disabledDatesBegin: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      disabledDatesEnd: {
        disabledDate(date) {
          return (
            date &&
            (date.valueOf() > Date.now() + 31536000000 ||
              date.valueOf() < Date.now() - 86400000)
          );
        },
      },
    };
  },
  async created() {
    this.$Spin.show();

    await this.getAtividades();
    await this.getTamanhos();
    await this.getFaturamentos();
    await this.getEstados();
    await this.getEmpresas();

    /**
     * Caso possua id nas props consulto os dados do cadastro [edição];
     */
    if (this.id > 0) {
      await this.getAviso(this.id);
    }

    this.$Spin.hide();
  },
  methods: {
    /**
     * Busca os dados do usuário para edição
     */
    async getAviso(id_aviso) {
      try {
        const { data } = await this.$axios.get(`aviso/${id_aviso}`);

        this.dados_aviso = data;

        this.dados_aviso.empresa = data.empresa ? JSON.parse(data.empresa) : [];

        this.dados_aviso.data_hora_inicio = moment(
          data.data_hora_inicio,
          "YYYY-MM-DD HH:mm:ss"
        ).format("DD/MM/YYYY HH:mm");
        this.dados_aviso.data_hora_fim = moment(
          data.data_hora_fim,
          "YYYY-MM-DD HH:mm:ss"
        ).format("DD/MM/YYYY HH:mm");

        this.dados_aviso.estado = this.dados_aviso.estado
          ? this.estados.filter(
              (estado) => estado.uf === this.dados_aviso.estado
            )[0].id_estado
          : "";

        if (this.dados_aviso.estado) {
          await this.getCidades();
        }

        setTimeout(() => {
          this.ativar_botao = false;
        }, 100);
      } catch (error) {
        console.warn(error);
      }
    },
    /**
     * Antes de salvar, valida os dados dos inputs
     */
    validar(name) {
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error({
            content: "Há campos não informados!",
            duration: 5,
          });
        } else {
          this.salvarAviso();
        }
      });
    },
    /**
     * Atualiza um cadastro existente, ou cria um novo
     */
    async salvarAviso() {
      try {
        let response;

        this.dados_aviso.dataHoraInicio = moment(
          this.dados_aviso.data_hora_inicio,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss");
        this.dados_aviso.dataHoraFim = moment(
          this.dados_aviso.data_hora_fim,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss");
        this.dados_aviso.empresa = this.dados_aviso.empresa
          ? this.dados_aviso.empresa
          : [];

        const dados = {
          ...this.dados_aviso,
          empresa: JSON.stringify(this.dados_aviso.empresa),
          estado: this.dados_aviso.estado
            ? this.estados.filter(
                (estado) => estado.id_estado === this.dados_aviso.estado
              )[0].uf
            : "",
        };

        if (this.dados_aviso.id_aviso) {
          response = await this.$axios.put(
            `aviso/${this.dados_aviso.id_aviso}`,
            dados
          );
        } else {
          response = await this.$axios.post(`aviso`, dados);
        }

        if (!response.data.code) {
          this.$Message.error({ content: response.data.message, duration: 5 });
          this.dados_aviso.empresa = this.dados_aviso.empresa
            ? JSON.parse(this.dados_aviso.empresa)
            : [];
        } else {
          this.$Message.success({
            content: "Dados salvos com sucesso!",
            duration: 5,
          });
          this.$emit("fecharDrawer", false);
        }
      } catch (error) {
        console.warn(error);
        this.$Message.error({ content: `Erro! ${error.message}`, duration: 5 });
      }

      this.$Spin.hide();
    },
    /**
     * Consumindo dados do consulta sobre atividades da empresa
     */
    async getAtividades() {
      try {
        const { data } = await this.$axios.get("consulta/atividades");
        this.atividades_empresa = data;
      } catch (ex) {
        console.warn(ex);
      }
    },
    /**
     * Consumindo dados do consulta sobre tamanhos da empresa
     */
    async getTamanhos() {
      try {
        const { data } = await this.$axios.get("consulta/tamanhos");
        this.tamanhos_empresa = data;
      } catch (ex) {
        console.warn(ex);
      }
    },
    /**
     * Consumindo dados do consulta sobre faturamentos da empresa
     */
    async getFaturamentos() {
      try {
        const { data } = await this.$axios.get("consulta/faturamentos");
        this.faturamentos_empresa = data;
      } catch (ex) {
        console.warn(ex);
      }
    },
    /**
     * Consulta os estados do País
     */
    async getEstados() {
      try {
        const { data } = await this.$axios.get("consulta/regions");
        this.estados = data;

        this.estados = data;
      } catch (ex) {
        console.warn(ex);
      }
    },
    /**
     * Ao escolher um estado no input, consulta as cidades deste estado.
     */
    async getCidades() {
      if ([undefined, ''].includes(this.dados_aviso.estado)) return;

      try {
        const { data } = await this.$axios.get(
          `consulta/regions/${this.dados_aviso.estado}/cities`
        );
        this.cidades = data;
      } catch (ex) {
        console.warn(ex);
      }
    },
    /**
     * Busca as cidades referente ao estado escolhido.
     */
    async getEmpresas() {
      const { data } = await this.$axios.get(`pessoa/empresas`);
      this.empresas = data;
    },
  },
  watch: {
    /**
     * Observa alterações nos dados, para exibir o botão de salvar
     */
    dados_aviso: {
      handler(newSettings, oldSettings) {
        this.ativar_botao = true;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.ivu-form-item {
  height: 59px;
}
.hide {
  display: none;
}
</style>
